import SalesHistories from './SalesHistories'
export default SalesHistories